import React from 'react';
import { isEndOfList } from '../../../Utils/scroll';
import Bar from './Indicator/Bar';
import Controls from './Indicator/Controls';

const Indicator = ({ currentSlide, imagesLength, handleSlide }) => {
  const onSlide = (direction) =>
    !isEndOfList(direction, currentSlide, imagesLength) &&
    handleSlide(direction);

  return (
    <div className="indicator">
      <Bar />
      <Controls
        currentSlide={currentSlide}
        imagesAmount={imagesLength}
        handleSlide={onSlide}
      />
    </div>
  );
};

export default Indicator;
